import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import Vue from 'vue'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  console.log('config.headers.noToken', config.noToken);

  if (store.getters.token && !config.noToken) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {

    const res = response.data
    console.log('***********', response);
    if (res.code == 200) {
      return response.data
    } else if (res.code == 401) {
      // 401:未登录;
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload()// 为了重新实例化vue-router对象 避免bug
        })
      })
    } else {
      if (!res.code) {
        return response.data
      }
    }
    Message({
      message: res.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject('error')

  },
  error => {
    // if (count == 0) loadingInstance.close()
    // if (axios.isCancel(error)) return Promise.reject(`${error}请求已取消`) //防止取消的请求抛出错误

    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js